//#region import libraries
import React, { useEffect, useState } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';

// styling
import { Colors } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectDistribution, selectDistributionError, selectDistributionStatus, updateDistributionInformation, selectCreateProduct, selectCreateProductStatus } from '_redux/slices/marketplace/create-product';


// custom components
import { CustomSpinner, ErrorMessage, IconPageTitle, SuccessMessage } from '_atoms';
import { CountrySelector, AirportListSelector } from '_molecules';

// icons
import { LiaShippingFastSolid } from "react-icons/lia";

// tremor
import { Flex } from '@tremor/react';
//#endregion

const DistributionForm = (props) => {

    //#region redux
    // redux
    const dispatch = useDispatch();

    // product redux
    const product = useSelector(selectCreateProduct);
    const productStatus = useSelector(selectCreateProductStatus);

    // distribution redux
    const distribution = useSelector(selectDistribution)
    const distributionError = useSelector(selectDistributionError);
    const distributionStatus = useSelector(selectDistributionStatus);
    //#endregion

    //#region local state
    // local states
    const [errors, setErrors] = useState({});
    const [showDeliveryModal, setShowDeliveryModal] = useState(false)
    const [showAirportModal, setShowAirportModal] = useState(false)

    // border colors
    const [contactBorder, setContactBorder] = useState('grey');
    const [linkBorder, setLinkBorder] = useState('grey');
    const [addressLine1Border, setAdrressLin1Border] = useState('grey');
    const [addressLine2Border, setAdrressLin2Border] = useState('grey');
    const [distributionOptionBorder, setDistributionOptionBorder] = useState('grey');
    const [cityBorder, setCityBorder] = useState('grey');
    const [countryBorder, setCountryBorder] = useState('grey');
    const [postalCodeBorder, setPostalCodeBorder] = useState('grey');
    const [countriesBorder, setCountriesBorder] = useState('grey');
    const [iataListBorder, setIataListBorder] = useState('grey');

    const [distributionFieldsValues, setDistributionFieldsValues] = useState({
        contactEmail: distribution?.contactEmail || '',
        refundPolicy: distribution?.refundPolicy || '',
        distributionOption: distribution?.distributionOption || '',
        addressLine1: distribution?.addressLine1 || '',
        addressLine2: distribution?.addressLine2 || '',
        city: distribution?.city || '',
        country: distribution?.country || '',
        postalCode: distribution?.postalCode || '',
        countries: distribution?.countries || '',
        iataList: distribution?.iataList || '',
        collectionInformation: distribution?.collectionInformation || ''
    })
    //#endregion

    //#region useEffect
    useEffect(() => {
        if (distributionStatus === 'succeeded') {
            setDistributionFieldsValues({
                contactEmail: '',
                refundPolicy: '',
                distributionOption: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                country: '',
                countries: '',
                postalCode: '',
                iataList: '',
                collectionInformation: ''
            })
        }
    }, [distributionStatus])

    //#region functions
    const manageAvailability = () => {
        setShowDeliveryModal(true)
    }
    //change fields input, update state, call validation function
    const handleChangeInput = (e) => {
        e.preventDefault();
        let { name, value } = e.target;
        //ToggleButton does not support name attribute, so we  need to add it manually!
        if (["DELIVERY-COLLECTION", "DELIVERY-ONLY", "COLLECTION-ONLY"].includes(value)) {
            name = "distributionOption"
        }
        setDistributionFieldsValues((prevState) => {
            const updatedFields = { ...prevState, [name]: value };
            // Call validateFields with updated state
            handleValidation(updatedFields);

            return updatedFields;
        });
    }
    //validate the fields
    const handleValidation = (fields) => {
        const tempErrors = {},
            { contactEmail, refundPolicy, distributionOption, addressLine1, city, country, countries, postalCode, iataList } = fields;

        const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const POLICY_LINK_REGEX = /^(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
        // check contact email
        if (contactEmail.length == 0 || !contactEmail.match(EMAIL_REGEX)) {
            tempErrors.contactEmail = "Please enter a valid email address"
            setContactBorder('red')
        } else { setContactBorder('green') }
        // check policy link
        if (refundPolicy.length == 0) {
            tempErrors.refundPolicy = "Please enter a valid refund policy link"
            setLinkBorder('red')
        } else { setLinkBorder('green') }
        // check distribution option
        if (distributionOption == undefined || !distributionOption.length) {
            tempErrors.distributionOption = "Please select a valid distribution option"
            setDistributionOptionBorder("red")
        } else { setDistributionOptionBorder("green") }

        // if delivery or both check for countries
        if (distributionOption == 'DELIVERY-ONLY' || distributionOption == 'DELIVERY-COLLECTION') {
            // check countries
            if (countries.length == 0) {
                tempErrors.countries = "Please select at least one country to deliver to"
                setCountriesBorder("red")
            } else { setCountriesBorder("green") }
        }
        // if collection or both check for address
        if (distributionOption == 'COLLECTION-ONLY' || distributionOption == 'DELIVERY-COLLECTION') {
            // check address details
            if (addressLine1.length == 0) {
                tempErrors.addressLine1 = "Please enter a valid address for Line 1"
                setAdrressLin1Border("red")
            } else {
                setAdrressLin1Border("green")
            }
            // check city
            if (city.length == 0) {
                tempErrors.city = "please enter a valid city";
                setCityBorder("red")
            } else { setCityBorder("green") }
            // check country
            if (country.length == 0) {
                tempErrors.country = "please enter a valid country";
                setCountryBorder("red")
            } else { setCountryBorder("green") }
            // check postal code
            if (postalCode.length == 0) {
                tempErrors.postalCode = "please enter a valid postal code";
                setPostalCodeBorder("red")
            } else setPostalCodeBorder("green")
            // check Collection airport
            if (iataList.length == 0) {
                tempErrors.iataList = "Please select at least one airport to deliver to";
                setIataListBorder("red")
            } else setIataListBorder("green")
        }


        setErrors(tempErrors)
        return tempErrors
    }
    // submit fields of distribution after checking its validation
    const handleSubmit = () => {
        const result = handleValidation(distributionFieldsValues);
        if (!Object.keys(errors).length && !Object.keys(result).length) {
            // post distribution information
            let params = { body: distributionFieldsValues, id: product.id };
            console.log('posting distribution information...', params);
            dispatch(updateDistributionInformation(params));
        }
    }
    // update countries value in state, validate value and close the deliver modal after select countries
    const handleSelectCountries = (countries) => {
        setCountriesBorder("green"),
            setDistributionFieldsValues((prevState) => {
                const updatedFields = { ...prevState, countries: countries };
                // Call validateFields with updated state
                handleValidation(updatedFields);

                return updatedFields;
            });
        setShowDeliveryModal(false)
    }

    // update iatalist (airports) value in state, validate value and close the deliver modal after select airports
    const handleSelectIataList = (iataList) => {
        setIataListBorder("green"),
            setDistributionFieldsValues((prevState) => {
                const updatedFields = { ...prevState, iataList: iataList };
                // Call validateFields with updated state
                handleValidation(updatedFields);

                return updatedFields;
            });
        setShowAirportModal(false)
    }
    //#endregion

    return (
        <>
            <Row>

                <Flex>
                    <div>
                        <IconPageTitle title={"Add Product Distribution Information"} subtitle={"Add the distribution information for your product listing"} icon={<LiaShippingFastSolid size={80} color={Colors.PRM_LIGHT_BLUE} />} topText={"Step 2."} back={props.back} />
                    </div>
                    <div>
                        <Button variant={distributionError ? "danger" : "primary"} onClick={handleSubmit} loading={false} style={{ width: 300 }} className="mt-2">
                            {distributionStatus === 'loading' ? <CustomSpinner size={'sm'} style={{ color: 'white' }} /> : 'Add Distribution Information'}
                        </Button>
                        {distributionError && <p className="text-danger">{distributionError}</p>}
                        {distributionStatus === 'succeeded' && <p className="text-success">Distribution information added successfully</p>}
                    </div>
                </Flex>

                <Container className='mt-3'>
                    <hr style={{ borderColor: Colors.PRM_LIGHT_BLUE }} />
                </Container>

                <Container>
                    {productStatus == 'succeeded' &&
                        <SuccessMessage title={"Successfully Created Product"}>{"Your product has successfully been saved to the PRM Marketplace Database. The next step involves setting up your product distribution options."}</SuccessMessage>
                    }
                    {
                        distributionError &&
                        <ErrorMessage title={"Error Creating Product"}>{distributionError}</ErrorMessage>
                    }
                </Container>

                {/* Contact Email & Refund Policy */}
                <Form.Group className='mt-4'>
                    <Row>
                        <Col>
                            <Form.Label style={{ color: contactBorder }}>Contact Email</Form.Label>
                            <Form.Control onChange={handleChangeInput} value={distributionFieldsValues.contactEmail} name="contactEmail" type="name" placeholder="Enter the retailer's contact email" style={{ borderColor: contactBorder }} />
                            {errors.contactEmail && (<p className="text-danger">{errors.contactEmail}</p>)}
                        </Col>
                        <Col>
                            <Form.Label style={{ color: linkBorder }}>Refund Policy Link</Form.Label>
                            <Form.Control onChange={handleChangeInput} value={distributionFieldsValues.refundPolicy} name="refundPolicy" type="name" placeholder="Enter the link to the product refund policy" style={{ borderColor: linkBorder }} />
                            {errors.refundPolicy && (<p className="text-danger">{errors.refundPolicy}</p>)}
                        </Col>
                    </Row>
                </Form.Group>

                {/* Distribution Option */}
                <Row className='mt-4'>
                    <Col>
                        <Form.Label style={{ color: distributionOptionBorder }}>Distribution Option</Form.Label>
                        <p style={{ fontSize: 16, fontWeight: '400' }}>Please choose if your product is available for collection, shipping or both</p>
                        <ToggleButtonGroup type="checkbox" value={distributionFieldsValues.distributionOption}>
                            <ToggleButton i id="tbg-btn-1" variant={distributionFieldsValues.distributionOption == 'DELIVERY-ONLY' ? "outline-success" : 'outline-primary'} value={'DELIVERY-ONLY'} name="distributionOption" onChange={handleChangeInput}>Delivery</ToggleButton>
                            <ToggleButton id="tbg-btn-2" variant={distributionFieldsValues.distributionOption == 'COLLECTION-ONLY' ? "outline-success" : 'outline-primary'} value={'COLLECTION-ONLY'} name="distributionOption" onChange={handleChangeInput}>Collection</ToggleButton>
                            <ToggleButton id="tbg-btn-3" variant={distributionFieldsValues.distributionOption == 'DELIVERY-COLLECTION' ? "outline-success" : 'outline-primary'} value={'DELIVERY-COLLECTION'} name="distributionOption" onChange={handleChangeInput}>Delivery & Collection</ToggleButton>
                        </ToggleButtonGroup>
                        {errors.distributionOption && (<p className="text-danger">{errors.distributionOption}</p>)}
                    </Col>
                </Row>

                {/* Delivery Countries */}
                {distributionFieldsValues.distributionOption == 'DELIVERY-ONLY' || distributionFieldsValues.distributionOption == 'DELIVERY-COLLECTION' ?
                    <Row className='mt-4'>
                        <Form.Label style={{ color: countriesBorder }}>Delivery Availability</Form.Label>
                        <p style={{ fontSize: 16, fontWeight: '400' }}>Please choose which countries your product is available for delivery within</p>
                        {distributionFieldsValues.countries && distributionFieldsValues.countries.length > 0 && <p>Available in {distributionFieldsValues.countries && distributionFieldsValues.countries.length} countries</p>}
                        <Container>
                            <Button onClick={manageAvailability} style={{ width: 200 }}>Manage Availability</Button>
                        </Container>
                        {errors.countries && (<p className="text-danger">{errors.countries}</p>)}
                    </Row>
                    : ""}

                {/* Collection Address */}
                {distributionFieldsValues.distributionOption == 'COLLECTION-ONLY' || distributionFieldsValues.distributionOption == 'DELIVERY-COLLECTION' ?
                    <Row>
                        <Form.Label className='mt-4' style={{ color: errors.addressLine1 ? 'red' : Colors.PRM_LIGHT_BLUE }}>Collection Information</Form.Label>
                        <p style={{ fontSize: 16, fontWeight: '600', opacity: 0.6 }}>Fill in the collection address and additional information about collecting your product</p>
                        <Form.Group className='mt-3'>
                            <Row>
                                <Col>
                                    {/* Address Line 1 */}
                                    <Form.Label style={{ color: addressLine1Border }}>Address Line 1</Form.Label>
                                    <Form.Control onChange={handleChangeInput} name='addressLine1' type="name" placeholder="Address Line 1" value={distributionFieldsValues.addressLine1.length ? distributionFieldsValues.addressLine1 : null} style={{ borderColor: addressLine1Border }} />
                                    {errors.addressLine1 && (<p className="text-danger">{errors.addressLine1}</p>)}
                                    {/* Address Line 2 */}
                                    <Form.Label className='mt-3' style={{ color: addressLine2Border }}>{"Address Line 2 (Optional)"}</Form.Label>
                                    <Form.Control onChange={handleChangeInput} name="addressLine2" type="name" placeholder="Address Line 2" value={distributionFieldsValues.addressLine2.length ? distributionFieldsValues.addressLine2 : null} style={{ borderColor: addressLine2Border }} />
                                    {errors.addressLine2 && (<p className="text-danger">{errors.addressLine2}</p>)}
                                    {/* Post Code */}
                                    <Form.Label className='mt-3' style={{ color: postalCodeBorder }}>Postal Code</Form.Label>
                                    <Form.Control onChange={handleChangeInput} name="postalCode" type="name" placeholder="Postal Code" value={distributionFieldsValues.postalCode ? distributionFieldsValues.postalCode : null} style={{ borderColor: postalCodeBorder }} />
                                    {errors.postalCode && (<p className="text-danger">{errors.postalCode}</p>)}
                                </Col>
                                <Col>
                                    {/* City */}
                                    <Form.Label style={{ color: cityBorder }}>City</Form.Label>
                                    <Form.Control onChange={handleChangeInput} name="city" type="name" placeholder="City" value={distributionFieldsValues.city ? distributionFieldsValues.city : null} style={{ borderColor: cityBorder }} />
                                    {errors.city && (<p className="text-danger">{errors.city}</p>)}
                                    {/* Country */}
                                    <Form.Label className='mt-3' style={{ color: countryBorder }}>Country</Form.Label>
                                    <Form.Control onChange={handleChangeInput} name="country" type="name" placeholder="Country" value={distributionFieldsValues.country ? distributionFieldsValues.country : null} style={{ borderColor: countryBorder }} />
                                    {errors.country && (<p className="text-danger">{errors.country}</p>)}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Form.Label className="mt-3" style={{ color: Colors.PRM_LIGHT_BLUE }}>Additional Information</Form.Label>
                                    <Form.Control as="textarea" style={{ height: '100px', borderColor: Colors.PRM_LIGHT_BLUE }} type="text" placeholder="Type any instructions you would like to be forwarded to customers" onChange={handleChangeInput} name="collectionInformation" value={distributionFieldsValues.collectionInformation} />
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Label className='mt-4' style={{ color: iataListBorder }}>Collection Airport</Form.Label>
                        <p style={{ fontSize: 16, fontWeight: '600', opacity: 0.6 }}>Choose which airports your product can be collected within</p>
                        <Container>
                            <Button onClick={() => { setShowAirportModal(true) }} style={{ width: 300 }}>Manage Collection Airports</Button>
                        </Container>
                        {errors.iataList && (<p className="text-danger">{errors.iataList}</p>)}

                    </Row>
                    : ""}

            </Row>


            {/* Delivery Modal */}
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" show={showDeliveryModal} onHide={() => { setShowDeliveryModal(false) }}>
                <CountrySelector cancel={() => { setShowDeliveryModal(false) }} done={handleSelectCountries} />
            </Modal>

            <Modal show={showAirportModal} onHide={() => { setShowAirportModal(false) }} size="lg" aria-labelledby="contained-modal-title-vcenter" >
                <AirportListSelector cancel={() => { setShowAirportModal(false) }} done={handleSelectIataList} />
            </Modal>
        </>
    )
}

export default DistributionForm;